import { Tooltip } from "@mui/material";
import { TET3Tooltip } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const Et3Tooltip = withLiteObserverAndTheme<TET3Tooltip>((props) => {
  const { children, title, placement } = props;

  return (
    <Tooltip title={title} placement={placement}>
      {children}
    </Tooltip>
  );
});
export default Et3Tooltip;
